import { Services } from "../../ServiceLocator";
import { postData } from "../Api/Actions";
import { calculatePrice, receiveConfiguration, setConfigurationChanged } from "../Configuration/Actions";
import { setWorkInProgress } from "../Ui/Actions";
import { sum } from "lodash";

export const ADD_FIELD = "BERT_ARCHIVE_ADD_FIELD";
export const REMOVE_FIELD = "BERT_ARCHIVE_REMOVE_FIELD";
export const UPDATE_FIELD = "BERT_ARCHIVE_UPDATE_FIELD";
export const UPDATE_LAYER = "BERT_ARCHIVE_UPDATE_LAYER";
export const UPDATE_GLOBAL_PARAMETER = "BERT_ARCHIVE_UPDATE_GLOBAL_PARAMETER";
export const RECEIVE_BERT_ARCHIVE_CONFIGURATION = "BERT_ARCHIVE_RECEIVE_BERT_ARCHIVE_CONFIGURATION";

export const addNewField = () => (dispatch) => {
  dispatch({
    type: ADD_FIELD,
  });
  dispatch(calculatePrice());
  dispatch(setConfigurationChanged(true));
};

export const removeField = (fieldId) => async (dispatch) => {
  await dispatch({
    type: REMOVE_FIELD,
    fieldId,
  });
  dispatch(calculatePrice());
  dispatch(setConfigurationChanged(true));
  return dispatch(updateOverallWidth());
};

export const updateField = (fieldId, key, value) => (dispatch) => {
  dispatch({
    type: UPDATE_FIELD,
    fieldId,
    key,
    value,
  });
  dispatch(setConfigurationChanged(true));
  dispatch(calculatePrice());
};

export const updateLayer = (fieldId, layerId, key, value) => (dispatch) => {
  dispatch({
    type: UPDATE_LAYER,
    fieldId,
    layerId,
    key,
    value,
  });
  dispatch(setConfigurationChanged(true));
  dispatch(calculatePrice());
};

export const updateGlobalParameterBertArchive = (key, value) => (dispatch) => {
  dispatch({
    type: UPDATE_GLOBAL_PARAMETER,
    key,
    value,
  });
  if (key !== "scaleFactor" && key !== "overallWidth") {
    dispatch(setConfigurationChanged(true));
    dispatch(calculatePrice());
  }
};

export const setBertArchive = (data) => (dispatch) => {
  dispatch({
    type: RECEIVE_BERT_ARCHIVE_CONFIGURATION,
    data,
  });
};

export const saveBertArchiveConfiguration = (configurationtype = "", screenshot) => (
  dispatch,
  getState
) => {
  const { configuration } = getState().Configuration;
  const bertArchive = getState().BertArchive;
  const configurationWithBertArchive = {
    ...configuration,
    code: configurationtype === 'cart' ? configuration.code : null,
    customdata: { ...configuration.customdata, bertArchive },
    screenshots: screenshot,
  };
  return dispatch(
    postData(
      "frontendapi/configurations",
      {
        configuration: configurationWithBertArchive,
        configurationtype,
      },
      receiveConfiguration
    )
  ).then((result) => {
    if (configurationtype === "print") {
      Services.store.dispatch(setWorkInProgress("pdfDownload", false));
    } else {
      Services.store.dispatch(setWorkInProgress("saveConfiguration", false));
    }
    return result;
  });
};

export const updateOverallWidth = () => (dispatch, getState) => {
  const { fields } = getState().BertArchive;
  const overallWidth =
    sum(
      fields.map((field) => {
        return Number(field.width.match(/\d+/));
      })
    ) + 56;
  dispatch(updateGlobalParameterBertArchive("overallWidth", overallWidth));
};
